import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Tracks from "./components/Tracks";
import MoshTeam from "./components/MoshTeam";
import Shows from "./components/Shows";
import Media from "./components/Media";
import Merch from "./components/Merch";
import About from "./components/About";
import Booking from "./components/Booking";
import Crew from "./components/Crew";
import Footer from "./components/Footer";
import AdminPage from "./components/AdminPage";
import { VideoProvider } from "./components/VideoContext";
import "./App.css";

function HomePage() {
  const observerRef = useRef(null);
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            observerRef.current.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" }
    );
    document.querySelectorAll(".reveal").forEach((el) => observerRef.current.observe(el));
    return () => observerRef.current?.disconnect();
  }, []);

  return (
    <VideoProvider>
      <div className="App font-body text-cream-soft" data-testid="caf-app">
        <Nav />
        <main>
          <Hero />
          <Tracks />
          <MoshTeam />
          <Shows />
          <Media />
          <Merch />
          <About />
          <Booking />
          <Crew />
        </main>
        <Footer />
      </div>
    </VideoProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(10,10,20,0.95)",
            border: "1px solid rgba(0,240,255,0.4)",
            color: "#FDF8F5",
            fontFamily: "Azeret Mono, monospace",
            fontSize: "13px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </BrowserRouter>
  );
}
